export default {
  "content": "<path d=\"M20.707 11.293a1.001 1.001 0 010 1.414l-7.5 7.5-1.414-1.415L17.587 13H4v-2h13.586l-5.792-5.792 1.413-1.415 7.5 7.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};